// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xU","a":"xV","show":"xW","header":"xX","title":"xY","close":"xZ","carouselWrapper":"x0","emblaSlide":"x1"};